import React, { Component } from 'react';
import { observer } from 'mobx-react';
import classnames from 'classnames';
import ContactDetails from './ContactDetails';
import ContactComment from './ContactComment';
import Bonuses from './Bonuses';
import { MainArea } from '../actions';
import { Discounts } from '../discounts';
import { History } from '../history';
import contactsStore from '../store/contactsStore';

@observer class ContactPage extends Component {
  constructor() {
    super();
    this.state = { display: 'none' };
    this.showActivities = this.showActivities.bind(this);
    this.showDiscounts = this.showDiscounts.bind(this);
    this.showHistory = this.showHistory.bind(this);
  }
  showActivities() {
    this.setState({ display: 'act' });
  }
  showDiscounts() {
    this.setState({ display: 'disc' });
  }
  showHistory() {
    this.setState({ display: 'hist' });
  }
  componentWillReceiveProps(nextProps) {
    const { match: { params: { subNr } } } = nextProps;
    contactsStore.fetchContactDetails(subNr);
  }

  componentDidMount() {
    const { match: { params: { subNr } } } = this.props;
    contactsStore.fetchContactDetails(subNr);
  }

  render() {
    const { match: { params: { subNr } } } = this.props;
    const { display } = this.state;
    const contact = contactsStore.getContactDetails(subNr);
    const buttons = [];
    let body = null;

    switch (display) {
      case 'none':
        // display nothing
        break;
      case 'act':
        const mainAreas = contact.actions.reduce(
          (areas, action) => {
            areas[action.areaMain] = areas[action.areaMain] || [];
            areas[action.areaMain].push(action);
            return areas;
          },
          {}
        );
        body = (
          <div>
            <h4>Activiteiten</h4>
            <div className="list-group">
              {Object.keys(mainAreas).map(mainArea => (
                <MainArea
                  key={mainArea}
                  mainArea={mainArea}
                  actions={mainAreas[mainArea]}
                />
              ))}
            </div>
          </div>
        );

        break;
      case 'disc':
        body = <Discounts discounts={contact.discounts} contact={contact} />;
        break;
      case 'hist':
        body = <History  history={contact.history} contact={contact} />;
        break;
      default:
        throw new Error(`Unkown display "${display}"`);
    }

    if (contact.actions && contact.actions.length) {
      buttons.push(
        <button key="act"
          className={classnames('btn btn-default', {
            active: display === 'act'
          })}
          onClick={this.showActivities}
        >
          Activiteiten
        </button>
      );
    }

    if (contact.discounts && contact.discounts.length) {
      buttons.push(
        <button key="disc"
          className={classnames('btn btn-default', {
            active: display === 'disc'
          })}
          onClick={this.showDiscounts}
        >
          Staffels
        </button>
      );
    }

    if (contact.history && contact.history.length) {
      buttons.push(
        <button key="hist"
          className={classnames('btn btn-default', {
            active: display === 'hist'
          })}
          onClick={this.showHistory}
        >
          Historie
        </button>
      );
    }

    return (
      <div>
        <ContactDetails contact={contact} />
        <ContactComment comment={contact.comment1} />
        <Bonuses bonuses={contact.bonuses} />

        <div className="btn-group">
          {buttons}
        </div>

        {body}
      </div>
    );
  }
}

export default ContactPage;



// WEBPACK FOOTER //
// ./src/contacts/ContactPage.js